/**
 * TanStack Query hooks for `igaming-depositing-player-count`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingDepositingPlayerCountQueryKeys,
	type CreateIgamingDepositingPlayerCountBody,
	type ListIgamingDepositingPlayerCountResponse,
	type IgamingDepositingPlayerCountRow,
} from "./api";

export function useIgamingDepositingPlayerCountList(): UseQueryResult<ListIgamingDepositingPlayerCountResponse, Error> {
	return useQuery({
		queryKey: igamingDepositingPlayerCountQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingDepositingPlayerCountCreate(): UseMutationResult<IgamingDepositingPlayerCountRow, Error, CreateIgamingDepositingPlayerCountBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositingPlayerCountQueryKeys.all });
		},
	});
}

export function useIgamingDepositingPlayerCountDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingDepositingPlayerCountQueryKeys.all });
		},
	});
}
